module.exports = __webpack_public_path__ + "img/file08.8a21874e.png";